import React, { useMemo } from 'react';
import { IVessel } from '../../../../../util/varibles/interface';
import styles from '../style.module.scss';

interface IProps {
    source: any[]
    vessels: IVessel[]
}

const Contracts: React.FC<IProps> = ({ source, vessels }) => {
    const vesselIds = useMemo(() => new Set(vessels.map(item => item.id)), [vessels]);
    return <>
        {source.map((item: any) => {
            const { start_time, finish_time, contract_code, isPermission, isOwn, vesselId } = item;

            if (isOwn === isPermission || !vesselIds.has(vesselId))
                return null;

            const style = {
                '--el-left': start_time,
                '--el-width': finish_time - start_time,
                top: `calc(var(--${vesselId}-top) + var(--more-height)`,
                height: `calc(var(--${vesselId}) + var(--more-height, 0px))`
            } as any

            return <div key={contract_code} {...{
                className: styles.contract,
                style,
                'data-is-own': isOwn,
            }} />
        })}
    </>;
};

export default Contracts;
